import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderSv from '@/components/sv/HeaderSv';
import FooterSv from '@/components/sv/FooterSv';
import HeroSectionSv from '@/components/sv/startpage/HeroSectionSv';
import StatisticsSectionSv from '@/components/sv/startpage/StatisticsSectionSv';
import CategoriesSectionSv from '@/components/sv/startpage/CategoriesSectionSv';
import KeyInsightsSectionSv from '@/components/sv/startpage/KeyInsightsSectionSv';
import NewsReportsSectionSv from '@/components/sv/startpage/NewsReportsSectionSv';
import WhistleblowerSectionSv from '@/components/sv/startpage/WhistleblowerSectionSv';
import TestimonialsSectionSv from '@/components/sv/startpage/TestimonialsSectionSv';
import FocusSectorsSectionSv from '@/components/sv/startpage/FocusSectorsSectionSv';
import StartupJourneySectionSv from '@/components/sv/startpage/StartupJourneySectionSv';

const IndexSv = () => {
  const navigate = useNavigate();
  const observerRef = useRef<IntersectionObserver>();

  useEffect(() => {
    observerRef.current = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, {
      threshold: 0.1
    });

    const timer = setTimeout(() => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(el => observerRef.current?.observe(el));
    }, 100);

    return () => {
      clearTimeout(timer);
      observerRef.current?.disconnect();
    };
  }, []);

  const handleViewReports = () => {
    navigate('/sv/reports');
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'hsl(var(--text-black))' }}>
      <HeaderSv />
      <HeroSectionSv />
      <StatisticsSectionSv />
      <CategoriesSectionSv />
      <FocusSectorsSectionSv />
      <KeyInsightsSectionSv />
      <StartupJourneySectionSv />
      <NewsReportsSectionSv handleViewReports={handleViewReports} />
      <WhistleblowerSectionSv />
      <TestimonialsSectionSv />
      <FooterSv />
    </div>
  );
};

export default IndexSv;
